"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductSeriesSearchModel = instanceOfProductSeriesSearchModel;
exports.ProductSeriesSearchModelFromJSON = ProductSeriesSearchModelFromJSON;
exports.ProductSeriesSearchModelFromJSONTyped = ProductSeriesSearchModelFromJSONTyped;
exports.ProductSeriesSearchModelToJSON = ProductSeriesSearchModelToJSON;
exports.ProductSeriesSearchModelToJSONTyped = ProductSeriesSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductSeriesSearchModel interface.
 */
function instanceOfProductSeriesSearchModel(value) {
    return true;
}
function ProductSeriesSearchModelFromJSON(json) {
    return ProductSeriesSearchModelFromJSONTyped(json, false);
}
function ProductSeriesSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'productSeriesName': json['productSeriesName'] == null ? undefined : json['productSeriesName'],
        'webSeriesName': json['webSeriesName'] == null ? undefined : json['webSeriesName'],
        'useStatus': json['useStatus'] == null ? undefined : json['useStatus'],
    };
}
function ProductSeriesSearchModelToJSON(json) {
    return ProductSeriesSearchModelToJSONTyped(json, false);
}
function ProductSeriesSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'productSeriesName': value['productSeriesName'],
        'webSeriesName': value['webSeriesName'],
        'useStatus': value['useStatus'],
    };
}
